import { useEffect, useRef } from 'react';

import { isIOS, isMobileByUA } from '@whelk/utils/src/checkUA';

export const useSoftBoard = (
  inputQuery: string,
  onOpenSoftBoard: (sence: string) => void,
  onCloseSoftBoard: (sence: string) => void,
) => {
  const originHeightRef = useRef<number>(0);

  // 特殊 ua 也许探测不到

  const getHieght = () => {
    return document.documentElement.clientHeight || document.body.clientHeight;
  };

  const canInvoke = () => {
    const inputEl = document.querySelector(inputQuery)!;
    if (!inputEl) {
      return false;
    }
    if (!isMobileByUA) {
      return false;
    }
    if (!originHeightRef.current) {
      return false;
    }
    return true;
  };

  const isFocusInputEl = () => {
    const inputEl = document.querySelector(inputQuery)!;
    if (inputEl) {
      return document.activeElement === inputEl;
    }
    return false;
  };

  const isTargetInputEl = (ev: Event) => {
    const inputEl = document.querySelector(inputQuery)!;
    if (inputEl) {
      return ev.target === inputEl;
    }
    return false;
  };

  useEffect(() => {
    originHeightRef.current = getHieght();
  }, []);

  // 安卓监听屏幕 resize
  // 苹果监听元素 focusIn

  const whenResize = (ev: Event) => {
    // 加这个是因为在软键盘收起的时候，需要手动触发一次 resize 事件以重新获得 innerHeight 并设置一个自定义的 css 变量。
    // 但本身这个函数就是监听 resize 的回调。如果不加这个，在安卓 ua 机器上触发了一次 resize，就会循环调用了。
    if (!ev.isTrusted) return;
    if (!canInvoke()) return;
    if (getHieght() < originHeightRef.current) {
      if (isFocusInputEl()) {
        onOpenSoftBoard('android');
      }
    } else {
      onCloseSoftBoard('android');
    }
  };
  const whenFocusIn = (ev: FocusEvent) => {
    if (isTargetInputEl(ev)) {
      onOpenSoftBoard('ios');
    }
  };
  const whenFocusOut = () => {
    onCloseSoftBoard('ios');
  };
  useEffect(() => {
    if (isMobileByUA && !isIOS) {
      window.addEventListener('resize', whenResize);
    }
    if (isMobileByUA && isIOS) {
      const inputEl = document.querySelector(inputQuery)! as HTMLElement;
      if (inputEl) {
        inputEl.addEventListener('focusin', whenFocusIn);
        inputEl.addEventListener('focusout', whenFocusOut);
      }
    }
    return () => {
      if (isMobileByUA && !isIOS) {
        window.removeEventListener('resize', whenResize);
      }
      const inputEl = document.querySelector(inputQuery)! as HTMLElement;
      if (isMobileByUA && isIOS) {
        if (inputEl) {
          inputEl.removeEventListener('focusin', whenFocusIn);
          inputEl.removeEventListener('focusout', whenFocusOut);
        }
      }
    };
  }, []);
};
